export default "__VITE_ASSET__DoUtojL3__"